// extracted by mini-css-extract-plugin
export default {"image":"Image_image__RQqUP","circle":"Image_circle__F-Tvr"};